var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableau = function SvgTableau(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 -2.5 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7099A6",
    d: "M123.93 11.593v11.64h-20.821v7.572h20.82V53.99h8.14V30.805h21.34v-7.571h-21.34V0h-8.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB912C",
    d: "M55.884 41.12v16.894H24.37v10.6h31.515v34.306h11.688V68.613H99.56v-10.6H67.572V24.229H55.884z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#59879B",
    d: "M187.953 41.12v16.894h-31.515v11.12h31.515v33.786h12.16V69.134h31.515v-11.12h-31.514V24.228h-12.161z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8762C",
    d: "M120.901 98.66v18.929H85.837v14.1h35.064v37.856h14.196V131.69h35.063v-14.101h-35.063V79.733H120.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6591",
    d: "M224.01 108.22v11.877h-21.341v9.605h21.34v23.707h10.648v-23.707h21.34v-9.605h-21.34V96.39H224.01z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7099A6",
    d: "M20.82 109.26v11.357H0v8.044h20.82v22.714h8.14V128.66l21.34-.757v-7.287H28.96V97.904h-8.14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C72035",
    d: "M55.884 162.731v16.893H24.37v11.12h31.515v33.786h12.161v-33.786H99.56v-11.12H68.045v-33.786h-12.16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F447E",
    d: "M187.953 162.731v16.893h-31.515v10.6h31.515v34.306h12.16v-34.306h31.515v-10.6h-31.514v-33.786h-12.161z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6591",
    d: "M122.936 205.65v11.83h-21.341v9.606h21.34v23.707h10.648v-23.707h21.34v-9.606h-21.34v-23.707h-10.647z"
  })));
};
export default SvgTableau;